import React from "react";

export const Logo = ({ size = 28, className = "", withWordmark = true, invert = false }) => {
  const stroke = invert ? "#F3F3F1" : "#0A0A0A";
  const fill = invert ? "#0A0A0A" : "#F3F3F1";
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="site-logo">
      <svg
        width={size * 2.4}
        height={size}
        viewBox="0 0 96 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="NewGenPharma logo"
      >
        {/* Capsule outline — two halves, tilted */}
        <g transform="rotate(-24 48 20)">
          <rect
            x="8"
            y="6"
            width="80"
            height="28"
            rx="14"
            ry="14"
            fill={fill}
            stroke={stroke}
            strokeWidth="1.5"
          />
          {/* Split line */}
          <line x1="48" y1="6" x2="48" y2="34" stroke={stroke} strokeWidth="1.5" />
          {/* Subtle highlight on left half */}
          <path
            d="M14 12 Q 20 8 28 8"
            stroke={stroke}
            strokeOpacity="0.35"
            strokeWidth="1"
            fill="none"
            strokeLinecap="round"
          />
        </g>
      </svg>
      {withWordmark && (
        <span
          className="font-display text-[18px] tracking-tight leading-none"
          style={{ color: stroke }}
        >
          NewGen<span className="italic">Pharma</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
